import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import VFButton from '../VFButton';
import VFLottieView from '../VFLottieView';
import VFText from '../VFText';

import styles from './StatusView.styles';

const StatusView = ({
  image,
  title,
  description,
  renderDescription,
  primaryButtonProps,
  secondaryButtonProps,
  lottieProps,
  textStyles,
  containerStyle,
}) => {
  const _renderDescription = () =>
    _.isFunction(renderDescription)
      ? renderDescription()
      : description && (
          <VFText
            i18nKey={description}
            style={[styles.viewDescription, textStyles?.description]}
            testKey={FoundationTestKeys.statusViewDescription}
          />
        );

  return (
    <View style={containerStyle} testID={FoundationTestKeys.statusViewContainerView}>
      <View
        style={textStyles?.textContainer}
        testID={FoundationTestKeys.statusViewTextContainerView}
      >
        <View
          style={styles.viewIconContainer}
          testID={FoundationTestKeys.statusViewIconContainerView}
        >
          {lottieProps ? (
            <VFLottieView {...lottieProps} testID={FoundationTestKeys.statusViewContainerLottie} />
          ) : (
            <Icon
              name={image}
              type="image"
              style={styles.iconContainer}
              testID={FoundationTestKeys.statusViewContainerIcon}
            />
          )}
        </View>

        {title && (
          <VFText
            i18nKey={title}
            style={[styles.title, textStyles?.title]}
            testKey={FoundationTestKeys.statusViewContainerTitle}
          />
        )}

        {_renderDescription()}
      </View>

      {primaryButtonProps && (
        <VFButton
          style={styles.viewButton(!!secondaryButtonProps)}
          textStyle={styles.viewButtonText}
          testKey={FoundationTestKeys.primaryButton}
          type="primary"
          {...primaryButtonProps}
        />
      )}

      {secondaryButtonProps && (
        <VFButton
          style={styles.viewButton()}
          textStyle={styles.viewButtonText}
          testKey={FoundationTestKeys.secondaryButton}
          type="secondary"
          {...secondaryButtonProps}
        />
      )}
    </View>
  );
};

StatusView.defaultProps = {
  textStyles: {},
};

StatusView.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  renderDescription: PropTypes.func,
  primaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
  secondaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
  lottieProps: PropTypes.object,
  textStyles: PropTypes.shape({
    textContainer: ViewPropTypes.style,
    title: TextPropTypes.style,
    description: TextPropTypes.style,
  }),
  containerStyle: ViewPropTypes.style,
};

export default StatusView;
